module.exports = __webpack_public_path__ + "assets/images/USDUNFIT5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDUNFIT5.png
// module id = 1470
// module chunks = 1